import * as React from "react";

import { Spinner } from "@blueprintjs/core";
import { css } from "glamor";

const styles = {
	stuff: css({ margin: "15% auto" }),
};

export default class Loading extends React.Component {
	public render() {
		return (
			<div {...styles.stuff}>
				<Spinner size={Spinner.SIZE_LARGE} />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Loading.tsx